import { Link } from 'react-router-dom';
import { comparisonData } from '@/mocks/siteData';

export default function WhatIsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold mb-4 whitespace-nowrap">
              Getting Started
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
              Everything You Need To Know About Sugargoo Spreadsheet
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4">
              Sugargoo Spreadsheet is a structured resource that helps shoppers discover products, compare options, understand quality information and save time when shopping through Sugargoo. Our independent platform curates and organizes product data into an accessible format, making the entire shopping experience smoother and more efficient for beginners and experienced users alike.
            </p>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6">
              Unlike traditional methods where you spend hours searching through forums and individual listings, a well-maintained Sugargoo Spreadsheet gives you instant access to organized categories, verified seller information, QC photo references and community-curated finds — all updated regularly to reflect the latest available products.
            </p>
            <Link
              to="/article/sugargoo-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              Access Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            <div className="px-5 py-4 border-b border-background-200/50">
              <h3 className="font-heading text-base font-semibold text-foreground-900">Spreadsheet vs Traditional</h3>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200/50">
                    <th className="text-left px-5 py-3 font-semibold text-foreground-700 whitespace-nowrap">Feature</th>
                    <th className="text-left px-5 py-3 font-semibold text-primary-700 whitespace-nowrap">Spreadsheet</th>
                    <th className="text-left px-5 py-3 font-semibold text-foreground-500 whitespace-nowrap">Traditional</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonData.map((row, idx) => (
                    <tr key={idx} className="border-b border-background-100 last:border-b-0">
                      <td className="px-5 py-3 font-medium text-foreground-700 whitespace-nowrap">{row.feature}</td>
                      <td className="px-5 py-3 text-primary-700">{row.spreadsheet}</td>
                      <td className="px-5 py-3 text-foreground-500">{row.traditional}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}